'use client';

import * as React from 'react';

import { Dashboard } from '@/shared/i18n';
import { ICourseData } from '../../types/course-data';
import { ContentSectionBody } from '../elements';
import { PaginationType } from '../../types/pagination';
import { EventBus } from '@/shared/utils';
import { DashboardEvents } from '../../events';

interface ContentsSectionProps {
  title: string;
  hasLink?: boolean;
  hasModal?: boolean;
  hasNavigationButtons?: boolean;
  hasNumberResults?: boolean;
  resultsNumber?: string;
  route?: string;
  children?: React.ReactNode;
  dict: Dashboard;
  eventBus: any /* EventBus<CatalogEvents> */;
  isLoading: boolean;
  isError: boolean;
  higlightItems?: boolean;
  lastCourseElementRef?: (node: HTMLElement | null) => void;
  type: 'slider' | 'grid';
  data: any;
  sliderBackgropColor?: string;
  pagination?: PaginationType;
  fetchMore?: (page: PaginationType['page'], pageSize: PaginationType['pageSize']) => void;
  onCardClickCallback?: (item: ICourseData) => void;
}

const ContentsSection: React.FC<ContentsSectionProps> = ({
  title,
  hasLink,
  isLoading = false,
  isError = false,
  hasModal = false,
  fetchMore,
  hasNavigationButtons = true,
  sliderBackgropColor,
  hasNumberResults,
  resultsNumber,
  higlightItems,
  pagination,
  eventBus,
  route,
  type,
  data,
  onCardClickCallback,
  lastCourseElementRef,
  dict,
}) => {
  return (
    <ContentSectionBody
      data={data}
      type={type}
      dict={dict}
      isError={isError}
      hasModal={hasModal}
      isLoading={isLoading}
      sliderBackgropColor={sliderBackgropColor}
      fetchMore={fetchMore}
      title={title}
      pagination={pagination}
      hasLink={hasLink}
      higlightItems={higlightItems}
      hasNavigationButtons={hasNavigationButtons}
      onCardClickCallback={onCardClickCallback}
      lastCourseElementRef={lastCourseElementRef}
    />
  );
};

export default ContentsSection;
